export default __webpack_public_path__ + "static/media/bag1.20f4c587.jpg";